/**
 * Display helpers for the Loss Runs summary tabs. The Annual Loss
 * Summary and Loss Ratio Analysis values are all backend-computed
 * (`/loss-runs/summary`); the FE only formats them.
 */

/** Render a 0–1 fraction as a whole-percent string. Unlike money cells,
 *  0 renders as "0%" (a real loss ratio), only non-finite → em dash. */
export function displayPercent(fraction: number): string {
    if (!Number.isFinite(fraction)) return "—";
    return `${Math.round(fraction * 100).toLocaleString("en-US")}%`;
}
